import { render, staticRenderFns } from "./ManagerAccount.vue?vue&type=template&id=255d89ca"
import script from "./ManagerAccount.vue?vue&type=script&lang=js"
export * from "./ManagerAccount.vue?vue&type=script&lang=js"
import style0 from "./ManagerAccount.vue?vue&type=style&index=0&id=255d89ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports